import { Component, Input, OnInit } from "@angular/core";
import { DashboardVisitorService } from "../dashboard-visitor.service";

@Component({
	selector: "caass-district-stats-ytd",
	templateUrl: "./district-stats-ytd.component.html",
	styleUrls: ["./district-stats-ytd.component.css"],
})
export class DistrictStatsYTDComponent implements OnInit {
	constructor(private dashboardService: DashboardVisitorService) {}

	ngOnInit(): void {
		this.UpdateOption();
	}

	ngOnChanges() {
		this.UpdateOption();
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	@Input() DistrictStatPanel: string;

	Title: string = "District Week to Date";
	OptionID: number = 0; //0 Week, 1 Month, 2 Year

	VisitorCount: string = "N/A";
	CheckPointCount: string = "N/A";
	DeniedEntryCount: string = "N/A";

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////

	loadData() {
		this.ResetData();

		var result = this.dashboardService.DistrictVisitorStatsSelect(this.OptionID);
		result.subscribe(
			(response) => {
				var data: any = response;

				try {
					this.VisitorCount = String(data.VisitorCount);
					this.CheckPointCount = String(data.CheckPointCount);
					this.DeniedEntryCount = String(data.DeniedEntryCount);
				} catch (e) {
					e.toString();
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "District Week to Date";
		} else if (this.OptionID == 1) {
			this.Title = "District Month to Date";
		} else if (this.OptionID == 2) {
			this.Title = "District Year to Date";
		}

		this.loadData();
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	ResetData() {
		this.VisitorCount = "N/A";
		this.CheckPointCount = "N/A";
		this.DeniedEntryCount = "N/A";
	}

	UpdateOption() {
		if (this.DistrictStatPanel != undefined) {
			if (this.DistrictStatPanel == "WTD") {
				this.OptionID = 0;
			} else if (this.DistrictStatPanel == "MTD") {
				this.OptionID = 1;
			} else if (this.DistrictStatPanel == "YTD") {
				this.OptionID = 2;
			}

			this.loadData();
		}
	}

	////////////////////////////////////////////////////////////////////////
}
